

















import { Component, Vue } from "vue-property-decorator";
import { RefuelingHistoryEntry } from "@/types/refuelingEvent";
import RefuelingEntry from "@/components/RefuelingEntry.vue";
import HistoryChart from "@/components/HistoryChart.vue";

@Component({
  components: {RefuelingEntry, HistoryChart}
})
export default class History extends Vue {
  get refuelings(): RefuelingHistoryEntry[] {
    return [...this.$store.state.refuelings];
  }
}
